export const GET_PROMO_SLIDER = "GET_PROMO_SLIDER";
